@if (!!photo.hasError) {
  <tg-aspect-ratio class="tm-list-photo-card__error" ratio="1x1">
    <button class="tm-list-photo-card__error-button">
      <span class="tm-list-photo-card__error-flex-container">
        <span class="tm-list-photo-card__error-icon-wrapper">
          <tg-icon
            class="tm-list-photo-card__error-icon"
            name="basic-warning-framed"
            role="presentation"
            >
          </tg-icon>
        </span>
        <span class="tm-list-photo-card__error-text">
          {{ photo.errorMessage }}
        </span>
        @if (activatable) {
          <span class="tm-list-photo-card__error-action-text">
            <tg-icon role="presentation" name="bin"> </tg-icon>
            Remove
            <span class="h-visually-hidden"> invalid photos </span>
          </span>
        }
      </span>
    </button>
  </tg-aspect-ratio>
}
@if (!photo.hasError) {
  @if (photo.loading && !url) {
    <tg-aspect-ratio
      class="tm-list-photo-card__loading"
      ratio="1x1"
      >
    </tg-aspect-ratio>
  }
  @if (photo.loading && !!url) {
    <tg-aspect-ratio
      [imageUrl]="url"
      class="tm-list-photo-card__loading"
      ratio="1x1"
      >
    </tg-aspect-ratio>
  }
  @if (!photo.loading) {
    <tg-aspect-ratio
      [imageUrl]="url"
      aria-label="listing image"
      class="tm-list-photo-card__valid"
      [ngClass]="{'thumbnail': isThumbnail}"
      ratio="1x1"
      >
      <ng-content></ng-content>
    </tg-aspect-ratio>
  }
}
